import {MeasurementUnitType} from '@wix/wixstores-graphql-schema/dist/es/src';

export const unitsTranslations = {
  [MeasurementUnitType.mg]: {
    abbr: 'gallery.units.mg.label',
    singular: 'gallery.sr.units.milligram.label',
    plural: 'gallery.sr.units.milligrams.label',
  },
  [MeasurementUnitType.g]: {
    abbr: 'gallery.units.g.label',
    singular: 'gallery.sr.units.gram.label',
    plural: 'gallery.sr.units.grams.label',
  },
  [MeasurementUnitType.kg]: {
    abbr: 'gallery.units.kg.label',
    singular: 'gallery.sr.units.kilogram.label',
    plural: 'gallery.sr.units.kilograms.label',
  },
  [MeasurementUnitType.ml]: {
    abbr: 'gallery.units.ml.label',
    singular: 'gallery.sr.units.milliliter.label',
    plural: 'gallery.sr.units.milliliters.label',
  },
  [MeasurementUnitType.cl]: {
    abbr: 'gallery.units.cl.label',
    singular: 'gallery.sr.units.centiliter.label',
    plural: 'gallery.sr.units.centiliters.label',
  },
  [MeasurementUnitType.l]: {
    abbr: 'gallery.units.l.label',
    singular: 'gallery.sr.units.liter.label',
    plural: 'gallery.sr.units.liters.label',
  },
  [MeasurementUnitType.cbm]: {
    abbr: 'gallery.units.cbm.label',
    singular: 'gallery.sr.units.cubicMeter.label',
    plural: 'gallery.sr.units.cubicMeters.label',
  },
  [MeasurementUnitType.mm]: {
    abbr: 'gallery.units.mm.label',
    singular: 'gallery.sr.units.millimeter.label',
    plural: 'gallery.sr.units.millimeters.label',
  },
  [MeasurementUnitType.cm]: {
    abbr: 'gallery.units.cm.label',
    singular: 'gallery.sr.units.centimeter.label',
    plural: 'gallery.sr.units.centimeters.label',
  },
  [MeasurementUnitType.m]: {
    abbr: 'gallery.units.m.label',
    singular: 'gallery.sr.units.meters.label',
    plural: 'gallery.sr.units.meters.label',
  },
  [MeasurementUnitType.sqm]: {
    abbr: 'gallery.units.sqm.label',
    singular: 'gallery.sr.units.squareMeter.label',
    plural: 'gallery.sr.units.squareMeters.label',
  },
  [MeasurementUnitType.oz]: {
    abbr: 'gallery.units.oz.label',
    singular: 'gallery.sr.units.ounce.label',
    plural: 'gallery.sr.units.ounces.label',
  },
  [MeasurementUnitType.lb]: {
    abbr: 'gallery.units.lb.label',
    singular: 'gallery.sr.units.pound.label',
    plural: 'gallery.sr.units.pounds.label',
  },
  [MeasurementUnitType.floz]: {
    abbr: 'gallery.units.flOz.label',
    singular: 'gallery.sr.units.fluidOunce.label',
    plural: 'gallery.sr.units.fluidOunces.label',
  },
  [MeasurementUnitType.pt]: {
    abbr: 'gallery.units.pt.label',
    singular: 'gallery.sr.units.pint.label',
    plural: 'gallery.sr.units.pints.label',
  },
  [MeasurementUnitType.qt]: {
    abbr: 'gallery.units.qt.label',
    singular: 'gallery.sr.units.quart.label',
    plural: 'gallery.sr.units.quarts.label',
  },
  [MeasurementUnitType.gal]: {
    abbr: 'gallery.units.gal.label',
    singular: 'gallery.sr.units.gallon.label',
    plural: 'gallery.sr.units.gallons.label',
  },
  [MeasurementUnitType.in]: {
    abbr: 'gallery.units.in.label',
    singular: 'gallery.sr.units.inch.label',
    plural: 'gallery.sr.units.inches.label',
  },
  [MeasurementUnitType.ft]: {
    abbr: 'gallery.units.ft.label',
    singular: 'gallery.sr.units.foot.label',
    plural: 'gallery.sr.units.feet.label',
  },
  [MeasurementUnitType.yd]: {
    abbr: 'gallery.units.yd.label',
    singular: 'gallery.sr.units.yard.label',
    plural: 'gallery.sr.units.yards.label',
  },
  [MeasurementUnitType.sqft]: {
    abbr: 'gallery.units.sqf.label',
    singular: 'gallery.sr.units.squareFoot.label',
    plural: 'gallery.sr.units.squareFeet.label',
  },
};
